import { useContext } from "react";
import { BackgroundTasksContext } from "./BackgroundTasksProvider";
import type { BackgroundTasksContextValue } from "./backgroundTasks.types";

export const useBackgroundTasks = (): BackgroundTasksContextValue => {
  const context = useContext(BackgroundTasksContext);
  if (!context) {
    throw new Error("useBackgroundTasks must be used within a BackgroundTasksProvider");
  }
  return context;
};

/** Tolerant variant for presentational components that may render without the provider (tests, storybook). */
export const useBackgroundTasksSafe = (): BackgroundTasksContextValue | null =>
  useContext(BackgroundTasksContext);
